import React, { ReactNode } from 'react';

import { withRouter, RouteComponentProps } from 'react-router-dom';
import { I18n, Translate } from 'react-redux-i18n';
import compteApi from '../../../../../network/api/compteApi';
import { ListMember } from '../../../../../network/api/types/compte/ListMember';
import CollaboratorsTile from './CollaboratorsTile';
import { MemberDTO } from '../../../../../network/api/types/compte/MemberDTO';
import Loader from '../../../../Loader';
import SearchButton from '../../../../common/inputs/SearchButton';
import { HOME_PAGE_ROUTE } from '../../../../../routes';
import { getStructureName } from '../../../../../services/utils';

type LocationState = {
  isManager: boolean
};

type Props = RouteComponentProps<unknown, null, LocationState> & {
  entityId: string
  onClose: () => void
};

type State = {
  entityName: string
  memberList: ListMember
  domaines: string[]
  idnRattachement: string
  searchString: string
  loading: boolean
};

class CollaboratorsInformation extends React.Component<Props, State> {
  state: State = {
    entityName: null,
    memberList: null,
    domaines: [],
    idnRattachement: null,
    searchString: '',
    loading: true,
  };

  searchButtonRef = React.createRef<HTMLButtonElement>();

  componentDidMount(): void {
    compteApi.fetchMyUserDetails()
      .then((myUserDetails) => {
        const entity = myUserDetails.entities
          .find((findEntity) => findEntity.id === this.props.entityId);
        this.setState({
          idnRattachement: entity.rattachement.id,
          entityName: getStructureName(entity),
        }, this.refreshList);
      })
      .catch(() => this.setState({ loading: false }));
    compteApi.getDomainesDactivite().then((domaines) => this.setState({ domaines }));
  }

  refreshList = (): void => {
    this.setState({ loading: true });
    compteApi.getMemberList(this.state.idnRattachement)
      .then((memberList) => this.setState({
        memberList,
        loading: false,
      }))
      .catch(() => this.setState({ loading: false }));
  };

  filterNameAndMail = (member: MemberDTO): boolean => {
    if (this.state.searchString === '') {
      return true;
    }
    return member.nomUsuel.toLowerCase().includes(this.state.searchString.toLowerCase())
      || member.nomDaffichage.toLowerCase().includes(this.state.searchString.toLowerCase())
      || member.prenom.toLowerCase().includes(this.state.searchString.toLowerCase())
      || member.email?.toLowerCase().includes(this.state.searchString.toLowerCase());
  };

  filterPhoneNumber = (member: MemberDTO): boolean => {
    const numberRegex = /\d/;
    if (!numberRegex.test(this.state.searchString)) {
      return false;
    }
    const trimmedNumbers = `${member.telephoneMobile?.replace(/ /g, '') || ''} ${member.telephoneFixe?.replace(/ /g, '') || ''}`;
    return trimmedNumbers.includes(this.state.searchString.replace(/ /g, ''));
  };

  render(): ReactNode {
    const filteredMemberList = this.state.memberList?.members
      .filter((member) => this.filterNameAndMail(member)
      || this.filterPhoneNumber(member))
      || [];
    const collaboratorStatut = this.state.memberList?.members
      .filter((member) => member.fonction?.toLowerCase().includes('collaborateur'))
      .filter((member) => member.statut === null).length !== 0 ? this.state.memberList?.members
      .filter((member) => member.fonction?.toLowerCase().includes('collaborateur'))
      .filter((member) => member.statut === null).length : null;
    let isManager;
    if (this.props.location.state) {
      isManager = this.props.location.state.isManager;
    } else this.props.history.push(HOME_PAGE_ROUTE);
    return (
      <div className="collaborators-info-drawer">
        <div className="collaborators-drawer-header">
          <div className="drawer-title">
            <h3>
              {this.state.entityName || (<Translate value="STRUCTURE_INFORMATION.NAME_PLACEHOLDER" />)}
            </h3>
            <div className="subtitle">
              <Translate value="COLLABORATORS_INFORMATION.COLLABORATORS_INFORMATION" />
            </div>
            <div className="additional-subtitle">
              <Translate value="PROFESSIONAL_INFORMATION.PUBLIC_INFORMATION" />
            </div>
          </div>
          <div className="drawer-divider-horizontal nofill" />
          <div className="collab-count-and-search">
            <span>
              {`${filteredMemberList?.length} membres`}
              {collaboratorStatut
              && collaboratorStatut !== 0
              && <span className="warning">{` - ${collaboratorStatut} collaborateurs avec un profil à compléter`}</span>}
            </span>
            <div className="button-container collaborator-search-div">
              <SearchButton
                placeholder={I18n.t('SEARCH.NAME_TEL')}
                onChange={(searchName) => this.setState({ searchString: searchName })}
              />
            </div>
          </div>
          <div className="drawer-divider-horizontal nofill" />
        </div>
        {filteredMemberList.length ? (
          <div className="collaborators-list">
            {this.state.memberList?.members.map((member) => (
              <CollaboratorsTile
                key={member.idn}
                entityId={this.props.entityId}
                member={member}
                domaines={this.state.domaines}
                refresh={this.refreshList}
                hidden={!filteredMemberList.includes(member)}
                isManager={isManager}
              />
            ))}
          </div>
        ) : this.state.loading && (
          <div className="loader-container">
            <Loader />
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(CollaboratorsInformation);
